import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clone } from 'lodash-es';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { LeafletMap } from '../../../components/LeafletMap';
import AreaDetailsPanel from './AreaDetailsPanel';
import AreasMapControlsBar from './AreasMapControlsBar';
import AreaZipcodes from './AreaZipcodes';
/**
 * @param {import('geojson').FeatureCollection | undefined} zipcodes
 * @param {import('geojson').Point | undefined} center
 * @param {Array<{name: string, value: number}>} teamOptions
 * @param {Record<number, string>} teamColors
 */
const AreaMap = ({ zipcodes, center, teamOptions, teamColors, }) => {
    const zoom = 10;
    const defaultTeam = teamOptions[0]?.value;
    // Make a shallow copy of GeoJSON features to prevent mutation of the original data
    const [zipcodeFeatures, setZipcodeFeatures] = useState(zipcodes?.features.map(clone) ?? []);
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [firstSelectedTeam, setFirstSelectedTeam] = useState(defaultTeam);
    const [openDialog, setOpenDialog] = useState(false);
    const handleDialogOpen = (open) => {
        setOpenDialog(open);
        if (!open) {
            setSelectedFeatures([]);
        }
    };
    useEffect(() => {
        if (selectedFeatures.length) {
            setOpenDialog(true);
        }
        else {
            setOpenDialog(false);
        }
    }, [selectedFeatures]);
    const setSelectedTeam = (teamId) => {
        const selectedTeamId = teamId ?? defaultTeam;
        if (selectedTeamId !== firstSelectedTeam) {
            setFirstSelectedTeam(selectedTeamId);
        }
    };
    return (_jsxs("div", { className: "relative rounded-lg overflow-hidden", children: [_jsx(AreasMapControlsBar, {}), _jsx(LeafletMap, { zoom: zoom, center: center, children: _jsx(AreaZipcodes, { zoom: zoom, zipcodeFeatures: zipcodeFeatures, selectedFeatures: selectedFeatures, setSelectedFeatures: setSelectedFeatures, setFirstSelectedTeam: setSelectedTeam, teamColors: teamColors }) }), _jsx(AreaDetailsPanel, { open: openDialog, setOpen: handleDialogOpen, zipcodeFeatures: zipcodeFeatures, setZipcodeFeatures: setZipcodeFeatures, teamOptions: teamOptions, teamColors: teamColors, selectedFeatures: selectedFeatures, firstSelectedTeam: firstSelectedTeam })] }));
};
AreaMap.propTypes = {
    zipcodes: PropTypes.shape({
        type: PropTypes.oneOf(['FeatureCollection']),
        features: PropTypes.array,
    }),
    center: PropTypes.shape({
        type: PropTypes.oneOf(['Point']),
        coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
    teamOptions: PropTypes.array,
    teamColors: PropTypes.object,
};
export default AreaMap;
